import React from "react";

const PartnersLogo = () => {
  return (
    <section className="section bg-light py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 text-center">
            <div className="section-title mb-4 pb-2">
              <h6 className="text-primary fw-bold mb-3">
                TRUSTED BY LEADING COMPANIES
              </h6>
              <h4 className="title mb-4">
                Partnered with Regulated Institutions
              </h4>
              <p className="text-muted para-desc mx-auto mb-0">
                Our technology infrastructure is built in partnership with
                RBI-regulated banks and financial institutions across India.
              </p>
            </div>
          </div>
          {/*end col*/}
        </div>
        {/*end row*/}

        <div className="row justify-content-center align-items-center g-3">
          {/* Logo cards with consistent sizing */}
          {/* <div className="col-lg-2 col-md-3 col-4 text-center">
            <div className="partner-logo-card p-3 bg-white rounded shadow-sm d-flex align-items-center justify-content-center">
              <img
                src="/images/hdfc_bank_logo.png"
                className="img-fluid partner-logo"
                alt="HDFC Bank"
              />
            </div>
          </div> */}
          {/*end col*/}

          <div className="col-lg-2 col-md-3 col-4 text-center">
            <div className="partner-logo-card p-3 bg-white rounded shadow-sm d-flex align-items-center justify-content-center">
              <img
                src="/images/mobikwik_logo.png"
                className="img-fluid partner-logo"
                alt="Mobikwik Logo"
              />
            </div>
          </div>
          {/*end col*/}

          <div className="col-lg-2 col-md-3 col-4 text-center">
            <div className="partner-logo-card p-3 bg-white rounded shadow-sm d-flex align-items-center justify-content-center">
              <img
                src="/images/easebuzz_logo.png"
                className="img-fluid partner-logo"
                alt="Easebuzz"
              />
            </div>
          </div>
          {/*end col*/}

          <div className="col-lg-2 col-md-3 col-4 text-center">
            <div className="partner-logo-card p-3 bg-white rounded shadow-sm d-flex align-items-center justify-content-center">
              <img
                src="/images/insurance_dekho_logo.png"
                className="img-fluid partner-logo"
                alt="Insurance Dekho"
              />
            </div>
          </div>
          {/*end col*/}

          <div className="col-lg-2 col-md-3 col-4 text-center">
            <div className="partner-logo-card p-3 bg-white rounded shadow-sm d-flex align-items-center justify-content-center">
              <img
                src="/images/protean_logo.png"
                className="img-fluid partner-logo"
                alt="Protean"
              />
            </div>
          </div>
          {/*end col*/}

          <div className="col-lg-2 col-md-3 col-4 text-center">
            <div className="partner-logo-card p-3 bg-white rounded shadow-sm d-flex align-items-center justify-content-center">
              <img
                src="/images/utiitls_logo.png"
                className="img-fluid partner-logo"
                alt="UTI"
              />
            </div>
          </div>
          {/*end col*/}
        </div>
        {/*end row*/}
      </div>
      {/*end container*/}

      {/* Add CSS to fix the issue */}
      <style jsx>{`
        .partner-logo-card {
          height: 50px; /* Fixed height for all cards */
          width: 100%;
        }

        .partner-logo {
          max-height: 22px; /* Maximum logo height */
          max-width: 100%; /* Ensure logo doesn't overflow horizontally */
          width: auto;
          object-fit: contain; /* Maintain aspect ratio */
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .partner-logo-card {
            height: 80px; /* Slightly smaller on mobile */
          }

          .partner-logo {
            max-height: 35px;
          }
        }

        @media (max-width: 576px) {
          .partner-logo-card {
            height: 75px;
          }

          .partner-logo {
            max-height: 30px;
          }
        }
      `}</style>
    </section>
  );
};

export default PartnersLogo;
